export default "__VITE_ASSET__DJPgs2yA__"